import classNames from 'classnames';
import { DetailedHTMLProps, forwardRef, InputHTMLAttributes, PropsWithChildren } from 'react';

import RadioSVG from './radio.svg';

import { WithFieldStateProps } from '../../hooks';

export interface RadioProps
  extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'type'>,
    WithFieldStateProps {
  inputClassName?: string;
  color?: 'primary' | 'secondary';
}

/**
 * Styled radio
 */
export const Radio = forwardRef<HTMLInputElement, PropsWithChildren<RadioProps>>((props, ref) => {
  const {
    children,
    color = 'primary',
    inputClassName,
    disabled,
    submitting,
    error,
    dirty,
    className,
    ...otherProps
  } = props;

  return (
    <label
      className={classNames(
        'relative flex items-center group',
        !disabled ? 'cursor-pointer' : 'cursor-default opacity-60 hover:bg-transparent',
        className
      )}
    >
      <div className="flex h-5 items-center">
        <input
          {...otherProps}
          ref={ref}
          type="radio"
          className={classNames(
            'cursor-pointer disabled:cursor-default h-5 w-5 rounded-full transition-colors ease-in-out duration-100',
            'appearance-none bg-white border-solid border-2 border-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2',
            'bg-[length:0] checked:bg-contain',
            'bg-no-repeat bg-center',
            'checked:border-transparent disabled:checked:bg-neutral-500',
            color === 'primary' && 'text-cyan-600 checked:bg-cyan-600',
            color === 'secondary' && 'text-gray-700 checked:bg-gray-700',
            inputClassName
          )}
          disabled={disabled}
          style={{ backgroundImage: `url(${RadioSVG})`, ...otherProps.style }}
        />
      </div>
      {children}
    </label>
  );
});

export default Radio;
